import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { format } from 'date-fns';
import React from 'react';


function Transition (props) {
  return <Slide direction='down' {...props} />;
}

const styles = () => ({
  dialog: {
    zIndex: 1320, // necessário pois deve ser carregado sobre um Modal
  },
});

class DialogSlideHistoricoGuia extends React.Component {
  render () {
    const { classes, open, title, historico, handleClose } = this.props;

    return (
      <React.Fragment>
        <Dialog
          open={open}
          className={classes.dialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
        >
          <DialogTitle>
            {title}
          </DialogTitle>
          <Divider />
          <DialogContent>
          <Table padding={'dense'}>
            <TableHead>
              <TableRow>
                <TableCell title='Situação da Guia'>Status</TableCell>
                <TableCell title='Nome do Usuário'>Usuário</TableCell>
                <TableCell title='Data do Cadastro'>Data</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {historico.slice(0).reverse().map((historico, idx) => {
                return (
                  <TableRow
                    key={idx}>
                    <TableCell>{historico.desEstadoGuia}</TableCell>
                    <TableCell>{historico.nomUsuario}</TableCell>
                    <TableCell>{format(new Date(historico.dtaCadastro), 'DD/MM/YYYY HH:mm:ss')}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          </DialogContent>
          <Divider />
          <DialogActions>
            <Button id={'fechar'} onClick={handleClose} color='primary'>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(DialogSlideHistoricoGuia);
